import * as Braze from '@braze/web-sdk';

// Configs
import { getGlobalState, STATE_KEYS } from '../configs/config_state';
import GLOBAL from '../configs/config_global';

export function startBrazeSDK() {
    Braze.enableSDK();

    // Re-initialize
    const initializationResult = Braze.initialize(
        getGlobalState(STATE_KEYS.IS_DEV) ? process.env.REACT_APP_KEY_BRAZE_SANDBOX : process.env.REACT_APP_KEY_BRAZE_PRODUCTION,
        { baseUrl: 'sdk.iad-06.braze.com', enableLogging: true, openCardsInNewTab: true, openInAppMessagesInNewTab: true }
    );
    GLOBAL.BRAZED_INITIATED = initializationResult;
    if (initializationResult) {
        Braze.automaticallyShowInAppMessages();
    }
}

export function stopBrazeSDK() {
    if (!GLOBAL.BRAZED_INITIATED) return;
    Braze.disableSDK();
    GLOBAL.BRAZED_INITIATED = false;
}
